import Vue from 'vue'
import Loading from '../components/Loading/plugin.vue'

export default {
  install(app: typeof Vue) {
    const VueLoading = app.extend(Loading)
    let loading: Vue
    app.prototype.$loading = {
      show(text: string) {
        if (!loading) {
          const ele = document.querySelector('body') as HTMLElement
          loading = new VueLoading()
          loading.$mount()
          loading.show(text)
          ele.appendChild(loading.$el)
        } else {
          loading.show(text)
        }
      },
      hide() {
        if (loading) {
          loading.hide()
        }
      },
      ...loading,
    }
  },
}
